var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconProductEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2791 4.545L2.7274 12.0967L1.6974 15.9383L1.0199 18.4692C1.00109 18.5399 1.00118 18.6143 1.02018 18.6849C1.03917 18.7556 1.07641 18.82 1.12814 18.8718C1.17988 18.9235 1.2443 18.9607 1.31496 18.9797C1.38562 18.9987 1.46003 18.9988 1.53074 18.98L4.0599 18.3017L7.9024 17.2717H7.90324L15.4549 9.71999L10.2799 4.545H10.2791ZM18.5774 5.42L14.5807 1.4225C14.5034 1.34504 14.4116 1.28359 14.3105 1.24167C14.2094 1.19974 14.101 1.17816 13.9916 1.17816C13.8821 1.17816 13.7738 1.19974 13.6727 1.24167C13.5716 1.28359 13.4797 1.34504 13.4024 1.4225L11.3399 3.48416L16.5157 8.66L18.5774 6.5975C18.6549 6.52017 18.7163 6.42834 18.7582 6.32724C18.8002 6.22614 18.8217 6.11777 18.8217 6.00833C18.8217 5.89888 18.8002 5.79051 18.7582 5.68942C18.7163 5.58832 18.6549 5.49649 18.5774 5.41916",
    fill: "#414B56"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProductEdit);
export default __webpack_public_path__ + "static/media/icon_product_edit.122650288ce53a351dc00d48db46d162.svg";
export { ForwardRef as ReactComponent };